import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Navigation } from "lucide-react";
import { useI18n } from "../context/I18nContext";

function directionsHref(address) {
  const q = encodeURIComponent(address || "Chennai");
  return `https://www.google.com/maps/dir/?api=1&destination=${q}`;
}

export default function Footer({ settings }) {
  const { t } = useI18n();
  return (
    <footer className="border-t border-[#282C33] bg-[#0A0B0E] mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display font-black uppercase tracking-tight text-3xl text-white">
            Diamondd <span className="text-[#00A896]">Traders</span>
          </div>
          <p className="text-[#8C939D] mt-4 max-w-md text-sm leading-relaxed">
            {settings?.tagline || t("footer.tagline")}
          </p>
          <div className="overline mt-6">{t("footer.operating")}</div>
        </div>

        <div>
          <div className="overline mb-4 text-[#8C939D]">{t("footer.sitemap")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-[#00A896]">{t("nav.home")}</Link></li>
            <li><Link to="/services" className="hover:text-[#00A896]">{t("nav.services")}</Link></li>
            <li><Link to="/gallery" className="hover:text-[#00A896]">{t("nav.gallery")}</Link></li>
            <li><Link to="/about" className="hover:text-[#00A896]">{t("nav.about")}</Link></li>
            <li><Link to="/contact" className="hover:text-[#00A896]">{t("nav.contact")}</Link></li>
            <li><Link to="/admin/login" className="text-[#8C939D] hover:text-[#00A896]" data-testid="footer-admin-link">{t("footer.admin")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4 text-[#8C939D]">{t("footer.reach")}</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-[#00A896] mt-0.5 shrink-0" />
              <a href={`tel:${settings?.mobile || ""}`} data-testid="footer-phone">{settings?.mobile}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-[#00A896] mt-0.5 shrink-0" />
              <a href={`mailto:${settings?.email || ""}`} data-testid="footer-email" className="break-all">{settings?.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#00A896] mt-0.5 shrink-0" />
              <div className="space-y-2">
                <span className="text-[#8C939D] block" data-testid="footer-address">{settings?.address}</span>
                {settings?.address && (
                  <a
                    href={directionsHref(settings.address)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-directions-btn"
                    className="inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-[0.2em] text-[#00A896] hover:text-[#02C39A] border border-[#00A896] hover:border-[#02C39A] px-3 py-1.5 transition-colors"
                  >
                    <Navigation size={12} /> {t("common.directions")}
                  </a>
                )}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#282C33] py-5 text-xs font-mono uppercase tracking-[0.2em] text-[#8C939D] text-center">
        © {new Date().getFullYear()} Diamondd Traders · {t("footer.copyright")}
      </div>
    </footer>
  );
}
